import { render } from "./ListaPartidas.vue?vue&type=template&id=a4afa086&scoped=true"
import script from "./ListaPartidas.vue?vue&type=script&lang=js"
export * from "./ListaPartidas.vue?vue&type=script&lang=js"

import "./ListaPartidas.vue?vue&type=style&index=0&id=a4afa086&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4afa086"]])

export default __exports__